module.exports = __webpack_public_path__ + "img/dna2_600.034260e8.jpg";